import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { getLanguage } from "../../../../utils/index.js";
import { useState } from "react";
import { Button, Modal, VideoPlayer } from "@nxt-costco-com/forge-components";
const MarkdownVideoLinkOverride = ({
  children,
  src,
  subTitleSrc,
  modalTitle,
  locale,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const language = getLanguage(locale);
  const tracks = subTitleSrc ? [
    {
      kind: "subtitles",
      src: subTitleSrc,
      srclang: language,
      label: language === "fr" ? "French" : "English",
      default: true
    }
  ] : [];
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Button, { variant: "text-button", onClick: () => setIsOpen(true), children }),
    /* @__PURE__ */ jsx(
      Modal,
      {
        closeButtonAriaLabel: "Close",
        modalTitle: modalTitle ? modalTitle : " ",
        hideBackdrop: false,
        isOpen,
        onClose: () => {
          setIsOpen(false);
        },
        children: /* @__PURE__ */ jsx(
          VideoPlayer,
          {
            options: {
              aspectRatio: "16:9",
              autoplay: true,
              controls: true,
              playsinline: true,
              responsive: true,
              sources: {
                src
              },
              tracks,
              language,
              muted: true
            },
            ...props
          }
        )
      }
    )
  ] });
};
export {
  MarkdownVideoLinkOverride
};
